import { combineReducers } from "@reduxjs/toolkit";
import viewPlanningCenterDocument from "./view-planning-center-document";

const viewPlanningCenterDocumentReducer = combineReducers({
  viewPlanningCenterDocument,
});

export default viewPlanningCenterDocumentReducer;
